import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { 
  FiBook, 
  FiEdit, 
  FiDollarSign, 
  FiAward,
  FiLogOut,
  FiMenu,
  FiX
} from "react-icons/fi";
import "./Navbar.css";

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="navbar-container">
        <div className="navbar-brand">
          <Link to="/app/dashboard" className="logo-link">
            <span className="logo-main">KESPODAK</span>
            <span className="logo-sub text-uppercase">Kebbi State, Nigeria</span>
          </Link>
        </div>

        <button 
          className="mobile-menu-toggle" 
          onClick={toggleMobileMenu}
          aria-label="Toggle navigation"
        >
          {isMobileMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
        </button>

        <nav className={`navbar-menu ${isMobileMenuOpen ? "active" : ""}`}>
          <ul className="nav-links">
            <NavItem 
              to="/app/materials" 
              icon={<FiBook />} 
              label="Study Materials" 
              currentPath={location.pathname}
              onClick={closeMobileMenu}
            />
            <NavItem 
              to="/app/registration" 
              icon={<FiEdit />} 
              label="Registration" 
              currentPath={location.pathname}
              onClick={closeMobileMenu}
            />
            <NavItem 
              to="/app/finance" 
              icon={<FiDollarSign />} 
              label="My Finance" 
              currentPath={location.pathname}
              onClick={closeMobileMenu}
            />
            <NavItem 
              to="/app/academic" 
              icon={<FiAward />} 
              label="My Academics" 
              currentPath={location.pathname}
              onClick={closeMobileMenu}
            />
            <NavItem 
              to="/" 
              icon={<FiLogOut />} 
              label="Sign Out" 
              currentPath={location.pathname}
              onClick={closeMobileMenu}
            />
          </ul>
        </nav>
      </div>
    </header>
  );
};

const NavItem = ({ to, icon, label, badge, currentPath, onClick }) => {
  const isActive = currentPath === to;
  return (
    <li className={`nav-item ${isActive ? "active" : ""}`}>
      <Link to={to} className="nav-link" onClick={onClick}>
        <span className="nav-icon">{icon}</span>
        <span className="nav-label">{label}</span>
        {badge > 0 && (
          <span className="nav-badge">
            {badge}
          </span>
        )}
      </Link>
    </li>
  );
};

export default Navbar;